import React from 'react';
import * as NotificationAPI from '../../../services/NotificationServices';
import { createFeedback } from '../../../services/FeedbackServices';
import styles from './styles/FeedbackModal.module.css';

const FeedbackModal = ({ userId, closeFeedbackModal, feedbackText, setFeedbackText, scenario, situation, assignmentId }) => {
    
    const handleSendFeedback = () => {
        const feedbackPayload = {
            text: feedbackText,
            recipient: scenario.creator,
            situationOrigin: situation._id,
            scenarioOrigin: scenario._id,
        };

        if (userId) {
            feedbackPayload.sender = userId;
        }
        if (assignmentId) {
            feedbackPayload.assignmentId = assignmentId;
        }

        createFeedback(feedbackPayload)
            .then(() => {
                const notificationPayload = { 
                    feedbackText: feedbackText 
                };
                if (assignmentId) {
                    notificationPayload.assignmentId = assignmentId;
                }
                NotificationAPI.sendFeedbackNotification(scenario.creator, notificationPayload);
            })
            .then(() => {
                closeFeedbackModal();
            })
            .catch(error => console.error('Error sending feedback:', error));
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <h2 className={styles.modalTitle}>Send Feedback</h2>
                <textarea
                    className={styles.textarea}
                    value={feedbackText}
                    onChange={(e) => setFeedbackText(e.target.value)}
                    placeholder="Enter your feedback here..."
                />
                <div className={styles.buttonContainer}>
                    <button onClick={closeFeedbackModal} className={`${styles.buttonBase} ${styles.closeButton}`}>
                        Close
                    </button>
                    <button onClick={handleSendFeedback} className={`${styles.buttonBase} ${styles.sendButton}`}>
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
